import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "./About.css";
import farmersImage from "../../assets/images/farmers.jpg";
import helpingFarmers from "../../assets/images/helping-farmers.jpg";
import foodEcosystem from "../../assets/images/eco-system.webp";

const About = () => {
  const { t } = useTranslation();
  const [showMore, setShowMore] = useState(false);
  const toggleReadMore = () => setShowMore((prev) => !prev);
  const detailCards = [
    {
      title: t("about.details.story_title"),
      text: t("about.details.story_text"),
    },
    {
      title: t("about.details.quality_title"),
      text: t("about.details.quality_text"),
    },
    {
      title: t("about.details.impact_title"),
      text: t("about.details.impact_text"),
    },
  ];

  useEffect(() => {
    const handleExpandRequest = () => {
      setShowMore(true);
    };

    window.addEventListener("about:expand", handleExpandRequest);
    return () => {
      window.removeEventListener("about:expand", handleExpandRequest);
    };
  }, []);

  return (
    <section id="about" className="about-section">
      <div className="about-container">
        <h2>{t("about.title")}</h2>
        <div className="underline"></div>
        <p className="tagline">{t("about.tagline")}</p>
        <div className="about-intro-section">
          <div className="intro-text">
            <p>{t("about.intro")}</p>
            {showMore && <p className="extra-info">{t("about.extra")}</p>}
            <button
              className="read-more-btn"
              onClick={toggleReadMore}
              aria-expanded={showMore}
            >
              {showMore ? t("about.read_less") : t("about.read_more")}
            </button>
          </div>
          <div className="intro-image">
            <img src={farmersImage} alt="Local farmers with fresh produce" loading="lazy" />
          </div>
        </div>
        {showMore && (
          <div className="about-details-section">
            <h3 className="details-heading">{t("about.details.heading")}</h3>
            <div className="details-grid">
              {detailCards.map((card) => (
                <article key={card.title} className="details-card">
                  <h4>{card.title}</h4>
                  <p>{card.text}</p>
                </article>
              ))}
            </div>
          </div>
        )}
        <div className="mission-section">
          <div className="mission-image">
            <img src={helpingFarmers} alt="Helping Farmers" loading="lazy" />
          </div>
          <div className="mission-text">
            <h3>{t("about.mission_title")}</h3>
            <p>{t("about.mission_text")}</p>
          </div>
        </div>
        <div className="vision-section">
          <div className="vision-text">
            <h3>{t("about.vision_title")}</h3>
            <p>{t("about.vision_text")}</p>
          </div>
          <div className="vision-image">
            <img src={foodEcosystem} alt="Food Ecosystem" loading="lazy" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
